import {Tag} from 'antd';
import React, {ReactNode, MouseEvent} from 'react';

import {ReactComponent as ClearIcon} from 'shared/assets/close.svg';

type TRawValueType = string | number;
type TKey = string | number;

interface ILabelValueType {
    key?: TKey;
    value?: TRawValueType;
    label?: ReactNode;
}

type TDefaultValueType = TRawValueType | TRawValueType[] | ILabelValueType | ILabelValueType[];

interface ITagRendererProps {
    label: TDefaultValueType;
    onClose: (event?: MouseEvent<HTMLElement>) => void;
    closable: boolean;
}

export const TagRenderer = (props: ITagRendererProps) => {
    const {
        label, closable, onClose,
    } = props;
    const onPreventMouseDown = (event: MouseEvent<HTMLSpanElement>) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <Tag
            onMouseDown={onPreventMouseDown}
            closable={closable}
            onClose={onClose}
            className="select-field__tag"
            closeIcon={<ClearIcon className="select-field__clear-icon" />}
        >
            {label}
        </Tag>
    );
};
